import { render, staticRenderFns } from "./ChoujianManage.vue?vue&type=template&id=bd27c546&scoped=true"
import script from "./ChoujianManage.vue?vue&type=script&lang=js"
export * from "./ChoujianManage.vue?vue&type=script&lang=js"
import style0 from "./ChoujianManage.vue?vue&type=style&index=0&id=bd27c546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd27c546",
  null
  
)

export default component.exports